const actions = {
  STORESESSIONDATA: 'STORESESSIONDATA',
  CLEAR_AUTH_DATA: 'CLEAR_AUTH_DATA',
  UPDATE_AUTH: 'UPDATE_AUTH',
  SESSION_VALID : 'SESSION_VALID',
  SIGNIN: {
    EMAIL: 'EMAIL',
    FACEBOOK: 'FACEBOOK'
  },
  SIGNUP: {
    EMAIL: 'EMAIL',
    FACEBOOK: 'FACEBOOK'
  },
  VERIFICATION : 'VERIFICATION',
  EDIT_PROFILE_IMAGE : 'EDIT_PROFILE_IMAGE',
  DASHBOARD: {
    ADD_SHIPMENT_PACKAGES: 'ADD_SHIPMENT_PACKAGES',
    ADD_CARRYING_PACKAGES: 'ADD_CARRYING_PACKAGES',
    ADD_RECEIVING_PACKAGES: 'ADD_RECEIVING_PACKAGES'
  },
  SHIPMENT: {
    ADD_SHIPMENT_DETAILS: 'ADD_SHIPMENT_DETAILS',
    ADD_NEW_Q_A : 'ADD_NEW_Q_A',
    ANSWER_A_QUESTION : 'ANSWER_A_QUESTION',
    ASK_QUESTION : 'ASK_QUESTION',
    FLAG_A_QUESTION : 'FLAG_A_QUESTION'
  },
  PROFILE: {
    ADD_PROFILE_DATA: 'ADD_PROFILE_DATA',
    PROFILE_REVIEWS: 'PROFILE_REVIEWS',
    UPDATE_PROFILE :'UPDATE_PROFILE',
    GET_NOTIFICATIONS : 'GET_NOTIFICATIONS',
    DELETE_NOTIFICATIONS : 'DELETE_NOTIFICATIONS',
    READ_NOTIFICATION : 'READ_NOTIFICATION'
  },
  MESSAGES: {
    MESSAGE_THREAD: 'MESSAGE_THREAD',
    UPDATE_MESSAGE_THREAD: 'UPDATE_MESSAGE_THREAD'
  },
  REQUEST_AN_ITEM : {
    STORE_REQUEST_DETAILS : 'STORE_REQUEST_DETAILS',
    CLEAR_REQUEST_DETAILS : 'CLEAR_REQUEST_DETAILS'
  },
  POST_A_SHIPMENT : {
    STORE_POST_A_SHIPMENT_DETAILS : 'STORE_POST_A_SHIPMENT_DETAILS',
    CLEAR_SHIPMENT_DETAILS : 'CLEAR_SHIPMENT_DETAILS'
  },
  BROWSE_PACKAGES: {
    BROWSE_PACKAGES: 'BROWSE_PACKAGES',
    BROWSE_PACKAGES_WITH_FILTERS: 'BROWSE_PACKAGES_WITH_FILTERS',
    UPDATE_MAP_VIEW: 'UPDATE_MAP_VIEW',
    UPDATE_LIST_PACKAGES: 'UPDATE_LIST_PACKAGES',
    UPDATE_MAP_PACKAGES: 'UPDATE_MAP_PACKAGES',
    BROWSE_PACKAGES_WITH_FILTERS: 'BROWSE_PACKAGES_WITH_FILTERS',
    OFFER_TO_CARRY_A_PACKAGE: 'OFFER_TO_CARRY_A_PACKAGE',
    SEND_MESSAGE: 'SEND_MESSAGE',
    TRANSPORT_DETAILS: 'TRANSPORT_DETAILS',
    MAKE_OFFER: 'MAKE_OFFER',
    CLEAR_MAKE_OFFER_DATA : 'CLEAR_MAKE_OFFER_DATA',
    GET_PAYPAL_ACCOUNT: 'GET_PAYPAL_ACCOUNT',
    ADD_PAYPAL_ACCOUNT: 'ADD_PAYPAL_ACCOUNT',
    ENABLE_TRIPS: 'ENABLE_TRIPS',
    CLEAR_MAP_DATA: 'CLEAR_MAP_DATA'

  },
  PAYMENT: {
     ADD_DETAILS: 'ADD_DETAILS',
     ADD_CARD: 'ADD_CARD',
     DELETE_CARD: 'DELETE_CARD',
     UPDATE_DEFAULT_CARD : 'UPDATE_DEFAULT_CARD'
  },
  USER_PROFILE: {
    VIEW_PROFILE: 'VIEW_PROFILE',
    PROFILE_REVIEWS: 'PROFILE_REVIEWS'
  },
  TRIPS : {
    GET_ALL_TRIPS : 'GET_ALL_TRIPS',
    UPDATE_TRIP : 'UPDATE_TRIP',
    DELETE_TRIP : 'DELETE_TRIP',
    CLEAR_TRIPS : 'CLEAR_TRIPS'
  }
}

function createConstant(obj) {
  function addPath(obj, path) {
    Object.keys(obj).forEach((key) => {
      const curPath = path ? path + '.' + key : key;
      if (typeof obj[key] == "string") {
        obj[key] = curPath;
      } else {
        addPath(obj[key], curPath)
      }
    });
  }
  return addPath(obj, "")
}

createConstant(actions);

module.exports = actions;



// WEBPACK FOOTER //
// app/action_constant.jsx